import { jsx as _jsx } from "react/jsx-runtime";
import { Text as DSText } from "@cinch-labs/design-system";
import cx from "classnames";
import styles from "./text.module.css";
export const Text = ({ children , className  })=>/*#__PURE__*/ _jsx(DSText, {
        element: "p",
        className: cx(styles.root, className),
        children: children
    });
